import * as Yup from "yup";
import { validateVerificationCode } from "../common";

export const settingMFAAuthAppSchema = Yup.object().shape({
  code: validateVerificationCode,
});
